import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  OnInit
} from '@angular/core';
import { UserService } from 'src/app/core/user.service';

@Directive({
  selector: '[hasPermission]'
})
export class HasPermissionDirective implements OnInit {
  per;
  constructor(
    private userService: UserService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
  ) { }

  ngOnInit() { }
    /**
     * will get permission from UI.
     * @havePermission passed user permission from UI.  
     * **/ 
  @Input()
  set hasPermission(havePermission) {
    this.per = havePermission;
    if (this.checkPermission(havePermission)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    };
  }

  /**
   * will check user has a permission to access a UI part.
   * @havePermission passed user permission from UI. 
   * **/ 
  private checkPermission(havePermission) {
    let permissionArr: any = [];
    const permissions = this.userService.userInfo?.permissions;
    havePermission.forEach((v) => {
      let permission = permissions?.some(c => c.resourceName === v)
      permissionArr.push(permission)
    })
    if (permissionArr.includes(true)) {
      return true;
    } else {
      return false;
    }
  }
}
